//#region src/core/i18n/text/cast.ts
const prefix = "cast.";
const startText = {
	key: `${prefix}start`,
	text: "Start casting"
};
const stopText = {
	key: `${prefix}stop`,
	text: "Stop casting"
};
const connectingText = {
	key: `${prefix}connecting`,
	text: "Connecting"
};
//#endregion
export { connectingText, startText, stopText };

//# sourceMappingURL=cast.js.map